export const usersTypes = {
  StartLoading: "[Users] StartLoading",
  FinishLoading: "[Users] Finish Loading",
  SetFetchError: "[Users] Set Fetch Error",
  SaveUsers: "[Users] Save Github Users",
};

export const userDetailsTypes = {
  StartLoading: "[User Details] Start Loading",
  FinishLoading: "[User Details] Finish Loading",
  SetFetchError: "[User Details] Set Fetch Error",
  SaveUser: "[User Details] Save User",
};
